function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.14962 0.962335L12.2338 7.29147L7.90621 10.2937L3.49746 7.26443L7.55464 0.962335C7.68983 0.745953 8.01443 0.745953 8.14962 0.962335Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17672 14.8378L12.5043 8.10289C12.5105 8.09055 12.5152 8.0782 12.5199 8.06623C12.527 8.04768 12.5339 8.02988 12.5452 8.01405L8.17672 11.0241C8.15975 11.0297 8.14398 11.0353 8.12891 11.0407L8.12852 11.0408C8.07158 11.0612 8.02441 11.0781 7.96035 11.0781C7.87917 11.0781 7.79805 11.0781 7.74391 11.0241L3.19995 7.88652C3.19995 7.96764 3.19995 8.04882 3.25404 8.10289L7.58168 14.8378C7.63575 14.9459 7.74391 15 7.87917 15C7.98739 15 8.12258 14.9459 8.17672 14.8378Z"
});

function SvgIconEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEth);
export default __webpack_public_path__ + "static/media/IconETH.af4eae16.svg";
export { ForwardRef as ReactComponent };